import type { DeployPlan } from "@/lib/stripe/deployPlan";
import { IconBuilding, IconRocket, IconSprout } from "@teral/icons";
import type { ComponentType } from "react";

type TierIconProps = {
  className?: string;
};

const TIER_ICONS: Record<DeployPlan, ComponentType<TierIconProps>> = {
  starter: IconSprout,
  pro: IconRocket,
  business: IconBuilding,
};

export function PlanTierIcon({ plan, className }: { plan: DeployPlan; className?: string }) {
  const Icon = TIER_ICONS[plan];
  return <Icon className={className} aria-hidden="true" />;
}
